import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (mesma convenção do certificado de regularidade PJ). */
export type DeclaracaoRtPgrssPjJob = ReportJob;
export type DeclaracaoRtPgrssPjJobStatus = JobStatus;

/** Job service (polling/sessionStorage/download) da Declaração de Responsabilidade Técnica pelo PGRSS. */
@Injectable({ providedIn: 'root' })
export class DeclaracaoRtPgrssPjJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'declaracao-rt-pgrss-pj-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.prestador.reports.declaracaoRtPgrssPj;
}
